import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import flag8 from "../../assets/images/flag8.png";
import flag_bd4 from "../../assets/images/flag_bd4.png";
import flag_usa4 from "../../assets/images/flag_usa4.png";
import success23 from "../../assets/images/success23.png";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { useHistory, Link, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import RefreshToken from "../../components/RefreshToken";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    marginBottom: "40px",
  },
  marginBottomStyle: {
    marginBottom: "20px",
  },
  rightAlign: {
    textAlign: "right",
  },
  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  inputStyle: {
    borderRadius: "8px",
  },
  inputStyle2: {
    borderRadius: "8px",
    // "& .MuiInputBase-input": {
    //   color: "#A2A2A2",
    // },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      fontSize: "14px",
      padding: 13,
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
  },

  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 13,
    },
  },
  selectStyle: {
    textAlign: "left",
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
    "& img": {
      position: "relative",
      top: "2px",
      marginRight: "5px",
    },
  },
  inputRoot: {
    "& .MuiOutlinedInput-input": {
      // color: "green",
      // fontWeight: 600,
    },
    "& .MuiInputLabel-root": {
      // color: "green",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "#eee",
      // backgroundColor: "#eee",
      color: "#333",
    },
    "&:hover .MuiOutlinedInput-input": {
      // color: "red",
    },
    "&:hover .MuiInputLabel-root": {
      // color: "red",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      // color: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      // color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      // borderColor: "purple",
    },
  },
  flag: {
    marginRight: 10,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
      borderWidth: 0,
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 8,
  },
  centerAlign: {
    textAlign: "center",
  },
}));
const ReceiverAuthentication = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const [confirm, setConfirm] = useState(false);
  const [countryCode, setCountryCode] = useState(10);

  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [loading, setLoading] = useState(false);

  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    let data = {
      transactionNumber: location.state.transactionNumber,
      originCountry: location.state.originCountry,
      mobileNumber: location.state.mobileNumber,
      otp: otp,
    };

    try {
      let res = await axios({
        url: `/api/v1/private/cashout/cash-pickup-response`,
        method: "post",
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("send res", res.data);

      history.push({
        pathname: "/transfer-receipt",
        state: {
          response: res.data.data,
          originData: { ...location.state, otp: otp },
        },
      });
    } catch (error) {
      console.log("err:::", error.response);

      let er = error.response && error.response.data.errors.toString();
      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    console.log("state", location.state);
  }, []);

  return (
    <>
      <div className={classes.root}>
        <Typography variant="h5" className={classes.marginBottomStyle}>
          Receiver Authentication
        </Typography>
        <form onSubmit={handleSendOtp}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={3}
          >
            <Grid item xs={3}>
              <Typography variant="body1">Transaction ID</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                id="otp"
                size="small"
                fullWidth
                placeholder="Enter OTP"
                variant="outlined"
                className={classes.textField}
                value={location.state.transactionNumber}
              />
            </Grid>

            <Grid item xs={3}>
              <Typography variant="body1">Country of Origin</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                id="otp"
                size="small"
                fullWidth
                placeholder="Enter OTP"
                variant="outlined"
                className={classes.textField}
                value={location.state.originCountry}
              />
            </Grid>

            <Grid item xs={3}>
              <Typography variant="body1">Mobile Number</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                id="otp"
                size="small"
                fullWidth
                placeholder="Enter OTP"
                variant="outlined"
                className={classes.textField}
                value={location.state.mobileNumber}
              />
            </Grid>

            <Grid item xs={3}>
              <Typography variant="body1">OTP</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                id="otp"
                size="small"
                required
                fullWidth
                placeholder="Enter OTP"
                variant="outlined"
                className={classes.textField}
                helperText="*A 4 digit code has been sent to the receiver mobile number. Enter it to continue"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} className={classes.rightAlign}>
              <Button
                variant="contained"
                // component={Link}
                // to="transfer-receipt"
                color="primary"
                type="submit"
                className={classes.buttonStyle}
              >
                Next
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </>
  );
};
export default ReceiverAuthentication;
